const ProgressAmount = ({ title, amount, percentage, className }) => {
  return (
    <div className={className}>
      <p className='caption  fw-semibold mb-2'>{title}</p>
      <div
        className='progress'
        role='progressbar'
        aria-label='Progress bar'
        aria-valuenow={percentage}
        aria-valuemin='0'
        aria-valuemax='100'
      >
        <div
          className='progress-bar  bg-primary-500'
          style={{ width: percentage }}
        />
      </div>
      <div className='d-flex justify-content-between mt-2'>
        <p className='caption '>{amount}</p>
        <p className='caption '>{percentage}</p>
      </div>
    </div>
  );
};

export default ProgressAmount;
